import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['tweetsTable']

  connect() {
    this.setDefaultLinkTarget()
  }

  setDefaultLinkTarget() {
    const nodes = this.tweetsTableTarget.querySelectorAll('a')
    // Use a normal for loop instead of a forEach method for IE support
    for (let i = 0; i < nodes.length; i++) {
      const link = nodes[i]
      if (link.hasAttribute('target') == false) {
        link.setAttribute('target', '_blank')
      }
    }
  }
}
